import axios from 'axios'

const http = axios.create({
    baseURL: ''
})

http.interceptors.request.use(
    function (config) {        
        const accessToken = localStorage.getItem("token")
        config.headers["Authorization"] = `Bearer ${accessToken}`;        
        
    return config

}, function (erro) {
    return Promise.reject(erro)
})

export default http